import React from 'react';
import LocationCard from "../../../../components/deprecatedUikit/LocationCard/LocationCard";
import {headCells} from "./data";
import LocationFavoriteIcon from "../../../../components/location/LocationFavoriteIcon";
import NotLiveLocationChip from "../../../../components/NotLiveLocationChip";
import {generateLocationProfileLink} from "../../../../util/LinkUtils";
import {LocationItemLinkRoot, LocationItemNonLinkRoot} from "../../../../components/location/styles";

const LocationCardList = ({locations}) => {
  return locations.map((location) => {
    // Only treat as offline when we explicitly know live is false; missing/undefined
    // keeps the link intact (safe default if the backend hasn't sent the flag yet).
    const isOffline = location.live === false;

    const card = (
      <LocationCard
        data={location}
        headCells={headCells}
        isBuyer
        statusChip={isOffline ? <NotLiveLocationChip /> : undefined}
        IconButton={() => <LocationFavoriteIcon locationId={location.locationId} isFavorite={location.isFavorite}/>}
      />
    );

    // Offline (deactivated) locations render without an href so buyers can't
    // navigate to an unavailable profile; the "Not Live" pill signals the state.
    return isOffline
      ? <LocationItemNonLinkRoot key={location.locationId}>{card}</LocationItemNonLinkRoot>
      : <LocationItemLinkRoot key={location.locationId} to={generateLocationProfileLink(location.locationId)} target={'_blank'} rel={'noopener noreferrer'}>{card}</LocationItemLinkRoot>;
  })
};

export default LocationCardList;
